import AppConfig from '@/AppConfig';
import { useEffect } from 'react';

function ThirdPartyScripts() {
  // Second useEffect: Handles loading Google Analytics (gtag.js)
  useEffect(() => {
    if (import.meta.env.PROD) {
      // Add preconnect for Google Analytics
      const preconnectLinkGA = document.createElement('link');
      preconnectLinkGA.rel = 'preconnect';
      preconnectLinkGA.href = 'https://www.googletagmanager.com';
      preconnectLinkGA.crossOrigin = 'anonymous';
      document.head.appendChild(preconnectLinkGA);

      // Add Google Analytics script
      const scriptGA = document.createElement('script');
      scriptGA.src = `https://www.googletagmanager.com/gtag/js?id=${AppConfig.GA_TRACKING_ID}`;
      scriptGA.async = true;
      scriptGA.defer = true;
      scriptGA.id = 'gtag-script';

      // Trigger a custom event when the script is loaded
      scriptGA.onload = () => {
        // Dispatch a custom event when gtag is loaded
        const gtagLoadedEvent = new CustomEvent(AppConfig.GA_LOADED_EVENT);
        window.dispatchEvent(gtagLoadedEvent);

        // Inline gtag initialization script
        const inlineGtagScript = document.createElement('script');
        inlineGtagScript.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag() { dataLayer.push(arguments); }
        gtag('js', new Date());

        // Configuring Google Analytics with your tracking ID
        gtag('config', '${AppConfig.GA_TRACKING_ID}', { send_page_view: false });

        // Send page view after load
        window.addEventListener('load', function() {
          gtag('event', 'page_view');
        });
      `;
        document.head.appendChild(inlineGtagScript);
      };

      // Error handling for script load failure
      scriptGA.onerror = () => {
        window.dev.e('Failed to load Google Analytics script.');
      };

      // Append the GA script
      document.head.appendChild(scriptGA);

      // Cleanup function to remove GA script, preconnect, and inline script
      return () => {
        document.head.removeChild(scriptGA);
        document.head.removeChild(preconnectLinkGA);
      };
    }
  }, []);

  return null;
}

export default ThirdPartyScripts;
